const BORDER_RADIUS_MULTIPLIER = 0.625

export const getItemBorderRadius = (cellWidth: number) => {
  return cellWidth * BORDER_RADIUS_MULTIPLIER
}
